import {getCurrentDifficulty} from '@domain/pom'
import {
  getSectionTopic,
  DataFetchingPlaceholder,
  ReferencesLink,
  TopicContainer,
  useSection,
  usePomNavigation,
  usePlantUpmId,
  useSectionId,
  useTopicId,
  usePlantContext,
  QuestionStateProvider,
  REFERENCES_LINK_TITLE_MARGIN_BOTTOM
} from '@features/pom'
import {PageTitle, PageContainer, BackToLink, TextOnBackground} from '@hconnect/uikit/src/lib2'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

export const PlantSubSectionPage: React.FC = () => {
  const {t} = useTranslation()
  const sectionId = useSectionId()
  const nav = usePomNavigation()
  const plantId = usePlantUpmId()
  const topicId = useTopicId()
  const {data: section, isLoading} = useSection()
  const topic = section ? getSectionTopic(section, topicId) : undefined
  const {data} = usePlantContext()
  const navigate = useNavigate()

  return (
    <PageContainer>
      <BackToLink
        targetName={section?.name ?? ''}
        target={nav.buildSectionPath(plantId, sectionId)}
        navigate={navigate}
      />
      <PageTitle ml={3} mb={topic?.guidanceLink ? 0 : REFERENCES_LINK_TITLE_MARGIN_BOTTOM}>
        {topic?.name}
        <TextOnBackground variant="caption" ml={1} contrast="low">
          {topic?.id}
        </TextOnBackground>
      </PageTitle>
      {data?.guidanceLink && (
        <ReferencesLink guidanceLink={data.guidanceLink} color="primary.contrastText" />
      )}
      {topic ? (
        <QuestionStateProvider
          data={{activeDifficulty: getCurrentDifficulty(topic.difficultySummaries)}}
        >
          <TopicContainer topic={topic} />
        </QuestionStateProvider>
      ) : (
        <DataFetchingPlaceholder isLoading={isLoading} errorMessage={t('errors.topicNotFetched')} />
      )}
    </PageContainer>
  )
}
